<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table
      :data="beforArr"
      style="width: 100%;overflow-y: scroll;min-width:800px"
      height="calc(100vh - 220px)"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="标题(疾病名称)" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.title ? scope.row.title : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="临床指南内容">
        <template slot-scope="scope">
          <span>{{ scope.row.message ? scope.row.message : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序(从大到小排序)" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="ejectupdateGoods(scope.row)">修改</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="deleteAdmin(scope.row)"
            :disabled="$store.state.supUser.roleId == 1"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增表单 -->
    <el-dialog :title="inputTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="标题" required>
          <el-input v-model="form.title" auto-complete="off" clearable placeholder="请输入疾病名称"></el-input>
        </el-form-item>
        <el-form-item label="临床指南内容" required>
          <el-input
            v-model="form.message"
            auto-complete="off"
            clearable
            placeholder="请输入"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" auto-complete="off" placeholder="默认为0"></el-input>
        </el-form-item>

        <el-form-item label="最后操作时间">
          <el-input v-model="form.createTime" auto-complete="off" placeholder="暂无" disabled></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectClinicalGuidelines,
  addClinicalGuidelines,
  updateClinicalGuidelines,
  deleteClinicalGuidelines
} from "@/services/doctor/clinicalGuidelines.js";
import { IP } from "@/services/index.js";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "新增",
      cover: "",
      fileList: [], //上传列表
      action: IP + "/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" }
      ],
      form: {},
      dialogFormVisible: false
    };
  },
  created() {

    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      let doctor_id = null;
      if (this.$store.state.supUser.roleId != 0) {
        doctor_id = this.$store.state.supUser.id;
      }
      selectClinicalGuidelines({
        doctor_id
      }).then(resp => {

        this.loading = false;
        this.beforArr = resp.data;
      });
    },
    // 新增按钮
    handleAdd() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
      this.fileList = [];
    },
    ejectupdateGoods(row) {
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    /* 上传图片 */
    handleSuccess_cover(e) {
      this.form.url = e.data;
      // console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      if (this.form.sort == "" || this.form.sort == null) {
        this.form.sort = 0;
      }
      if (!this.form.title || !this.form.message) {
        this.$message({
          type: "info",
          message: "请输入完整信息"
        });
        return;
      }
      if (this.inputTitle == "新增") {
        console.log(this.form);
        addClinicalGuidelines({
          ...this.form,
          doctor_id: this.$store.state.supUser.id
        }).then(res => {
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.selectData();
          } else {
            this.$message({
              type: "info",
              message: "网络错误"
            });
          }
        });
        return;
      }

      updateClinicalGuidelines(this.form).then(res => {
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.selectData();
        } else {
          this.$message({
            type: "info",
            message: "网络错误"
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteClinicalGuidelines(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.userNanme:hover {
  cursor: pointer;
}
</style>
